// Web mock for react-native-qrcode-svg
// Uses a simple QR code rendering via canvas-based approach
import React from 'react';
import { View } from 'react-native';

interface QRCodeProps {
  value: string;
  size?: number;
  color?: string;
  backgroundColor?: string;
  logo?: any;
  logoSize?: number;
  logoBackgroundColor?: string;
  logoBorderRadius?: number;
  logoMargin?: number;
  getRef?: (ref: any) => void;
}

const QRCode: React.FC<QRCodeProps> = ({
  value,
  size = 100,
  color = '#000000',
  backgroundColor = '#FFFFFF',
}) => {
  // Use a third-party QR code API for rendering
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}&color=${color.replace('#', '')}&bgcolor=${backgroundColor.replace('#', '')}`;

  return (
    <View style={{ width: size, height: size }}>
      <img
        src={qrUrl}
        alt="QR Code"
        style={{ width: size, height: size }}
      />
    </View>
  );
};

export default QRCode;
